import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { UserService } from './user.service';

import { Platform } from '@ionic/angular';

import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';

import { Router } from '@angular/router';


import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';

//import { LottieSplashScreen } from '@awesome-cordova-plugins/lottie-splash-screen/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
 
  /**
   * An object representing the user for the login form
   */
 
  constructor(/*private lottieSplashScreen: LottieSplashScreen, */
  private platform: Platform,
  private translate: TranslateService,
  private _userService: UserService,
  private iab: InAppBrowser,
  private router: Router
  ) {

    //this.lottieSplashScreen.hide();
    //this.lottieSplashScreen.show("public/assets/lottieFile/splash.json", false, 768, 1024)
    //.then((res: any) => console.log(res))
    //.catch((error: any) => console.error(error));

    //this.showSplash();

  }

  private async showSplash() {
    
    await this.platform.ready();
    
    const lottie = (window as any).lottie;

    if ( this.platform.is('ios') && lottie ) {

      await lottie.splashscreen.hide();
      await lottie.splashscreen.show("public/assets/lottieFile/splash.json", false);

    }
     

  }
 
  ngOnInit() {
    
    this.translate.setDefaultLang('en');
    this.translate.use(this._userService.getAppLanguage());
    //this.translate.use('en');
    //this.translate.get('tab1.tabName').subscribe((text: string) => { console.log('HERE: ', text); });



    // Request permission to use push notifications
    // iOS will prompt user and return if they granted permission or not
    // Android will just grant without prompting
    PushNotifications.requestPermissions().then(result => {
      if (result.receive === 'granted') {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        // Show some error
      }
    });

    // On success, we should be able to receive notifications
    PushNotifications.addListener('registration',
      (token: Token) => {
        console.info('Push registration success, token: ' + token.value);
      }
    );

    // Some issue with our setup and push will not work
    PushNotifications.addListener('registrationError',
      (error: any) => {
        console.info('Error on registration: ' + JSON.stringify(error));
      }
    );

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener('pushNotificationReceived',
      (notification: PushNotificationSchema) => {
        console.info('Push received: ' + JSON.stringify(notification));
      }
    );

    // Method called when tapping on a notification
    PushNotifications.addListener('pushNotificationActionPerformed',
      (notification: ActionPerformed) => {
        console.info('Push action performed: ' + JSON.stringify(notification));

        if ( notification.notification.data['openurl']) {

          const browser = this.iab.create(notification.notification.data['openurl']);
          browser.show();

        }

        else if (notification.notification.data['openroute']) {

          this.router.navigate([notification.notification.data['openroute']]);

        }

      }
    );



  }

 
}